<template>
  <el-card
    style="height: 100%; width: 100%"
    body-class="flex flex-col gap-4"
    :body-style="{
      height: '100%',
      width: '100%',
    }"
    shadow="always">
    <NotesEditor v-if="application" :application="application" />
  </el-card>
</template>

<script setup lang="ts">
  import { computed, watchEffect } from 'vue'
  import { useRoute } from 'vue-router'
  import { useApplicationDetailsStore } from '@/stores/ApplicationDetailsView.store'

  const route = useRoute()
  const applicationDetailsStore = useApplicationDetailsStore()

  const applicationId = computed(() => {
    const param = route.params.id
    return Array.isArray(param) ? param[0] : (param as string)
  })

  watchEffect(() => {
    if (applicationId.value) {
      applicationDetailsStore.loadApplicationDetails(applicationId.value)
    }
  })

  const application = computed(() => applicationDetailsStore.application)
</script>
